import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom';
import { Box, Flex, Heading, Fade } from "@chakra-ui/react"
import { useSelector, useDispatch } from 'react-redux';

import { verifyTokenAction, logInAction } from "../../redux/actions/auth.action"

import FullPageSpinner from "../../components/FullPageSpinner"
import LoginInForm from "./LoginInForm"

import { MAP_VIEW } from "../../routes/path"

export default function LogIn() {
  const dispatch = useDispatch()
  const { logInError, logInPending, isAuthenticated, verifyTokenPending } = useSelector(
    (state) => state.authStates
  );

  useEffect(() => {
    dispatch(verifyTokenAction());
  }, [dispatch]);

  if (isAuthenticated) {
    return <Redirect to={{ pathname: MAP_VIEW }} />;
  }
  
  if (verifyTokenPending) {
    return <FullPageSpinner></FullPageSpinner>
  }

  const onSubmit = (values) => {
    dispatch(logInAction(values));
  }

  return (
    <Fade in ={true}>
      <Flex minHeight='100vh' width='full' align='center' justifyContent='center'>
        <Box
          borderWidth={1}
          px={4}
          width='full'
          maxWidth='500px'
          borderRadius={8}
          textAlign='center'
          boxShadow="lg"
        >
          <Box p={4}>
            <Box textAlign='center'>
              <Heading as="h4" size="lg">
                Sign in
              </Heading>
            </Box>
          </Box>
          <LoginInForm logInError={logInError} logInPending={logInPending} onSubmit={onSubmit}></LoginInForm>
        </Box>
      </Flex>
    </Fade >
  )
}
